// extracted by mini-css-extract-plugin
module.exports = {"sortingWrap":"sorting_sortingWrap__F20yT","sortingLabel":"sorting_sortingLabel__ew0Tz","sortingDropdown":"sorting_sortingDropdown__od3Qo"};